import doQuery from './query';

export async function getCurrentUserWithBreweries() {
  const currentUser = await doQuery(`
    query {
      currentUser {
        id
        firebaseUid
        firstName
        lastName
        avatarIcon
        breweries {
          id
          name
          country {
            timezone
            upcomingBrewCustomsReport
          },
          role {
            id
            permissions
          }
          settings {
            id
            defaultLotVolume
          }
        }
      }
    }`);

  if (currentUser.error) {
    console.error('Error getting current user and breweries', currentUser.error);
    throw new Error('Error getting current user and breweries');
  }

  return currentUser.data.currentUser;
}



// WEBPACK FOOTER //
// ./src/graphql/users.js